export default function PieIcon5050Small() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.00001" cy="7.99992" r="6.47413" fill="#0A9373" fillOpacity="0.25" />
      <path
        d="M8 1.52583C7.14981 1.52583 6.30794 1.69329 5.52246 2.01865C4.73698 2.344 4.02328 2.82089 3.4221 3.42206C2.82092 4.02324 2.34404 4.73695 2.01868 5.52242C1.69332 6.3079 1.52587 7.14977 1.52587 7.99997C1.52586 8.85016 1.69332 9.69203 2.01868 10.4775C2.34403 11.263 2.82092 11.9767 3.42209 12.5779C4.02327 13.1791 4.73698 13.6559 5.52245 13.9813C6.30793 14.3066 7.1498 14.4741 8 14.4741L8 7.99997L8 1.52583Z"
        fill="#0A9373"
      />
    </svg>
  );
}
